import { Box, Heading, Text, Input, Select, Button, Alert, AlertIcon, Table, Thead, Tbody, Tr, Th, Td } from '@chakra-ui/react'

export default function Reminders ({ stage, reminders, setReminders }) {
  function addReminder () {
    let newReminders = Object.assign([], reminders)
    let hourToAdd = 8
    const existingHours = newReminders.map(r => r.hour)
    for (let i = 9; i < 23; i++) {
      if (existingHours.indexOf(i) === -1) {
        hourToAdd = i
        break
      }
    }
    newReminders.push({ hour: hourToAdd, title: stage?.name || 'Trialflare reminder', body: 'Please remember to submit data today.' })
    newReminders = newReminders.sort((a, b) => a.hour >= b.hour)
    setReminders(newReminders)
  }
  function removeReminder (hour) {
    const newReminders = Object.assign([], reminders)
    const hourToRemove = parseInt(hour)
    setReminders(newReminders.filter(r => r.hour !== hourToRemove))
  }
  function updateReminder (index, update) {
    let newReminders = Object.assign([], reminders)
    if (update.hour) {
      update.hour = parseInt(update.hour)
      const existingHours = newReminders.map(r => r.hour)
      if (existingHours.indexOf(update.hour) > -1) {
        return window.alert('You can\'t send two reminders in the same hour.')
      }
    }
    const reminder = Object.assign({}, newReminders[index], update)
    newReminders[index] = reminder
    newReminders = newReminders.sort((a, b) => a.hour >= b.hour)
    setReminders(newReminders)
  }

  return (
    <Box p={3} mt={15} borderWidth='1px' rounded='md' bg='gray.50'>
      <Heading as='h3' size='md'>Reminders</Heading>
      <Text color='gray.500' mb={5}>Send push notifications to participants to remind them to complete this stage.</Text>

      <Alert status='warning'>
        <AlertIcon /> Reminders can only be sent to participants that have enabled push notifications on their device.
      </Alert>

      <Text mt={3} mb={3}>Trialflare will try to send a push notification to participants for each day this stage is valid at the following hours:</Text>
      {reminders?.length > 0
        ? (
          <Table variant='striped'>
            <Thead>
              <Tr>
                <Th>Send at (UTC)</Th>
                <Th>Reminder title</Th>
                <Th>Reminder body</Th>
                <Th />
              </Tr>
            </Thead>
            <Tbody>
              {reminders.map((reminder, i) =>
                <Tr key={reminder.hour}>
                  <Td>
                    <Select
                      bg='white'
                      w='200px' placeholder='Select an hour of the day' value={reminder.hour ?? ''}
                      onChange={e => updateReminder(i, { hour: e.target.value })}
                    >
                      {Array.from({ length: 24 }, (_, i) => i).map(hour =>
                        <option key={hour} value={hour}>{hour < 10 && '0'}{hour}:00</option>
                      )}
                    </Select>
                  </Td>
                  <Td><Input bg='white' value={reminder.title ?? ''} onChange={e => updateReminder(i, { title: e.target.value })} placeholder='Notification title' /></Td>
                  <Td><Input bg='white' value={reminder.body ?? ''} onChange={e => updateReminder(i, { body: e.target.value })} placeholder='Notification body' /></Td>
                  <Td><Button size='xs' colorScheme='red' onClick={e => removeReminder(reminder.hour)}>Remove</Button></Td>
                </Tr>
              )}
            </Tbody>
          </Table>)
        : <Text color='gray.500' fontSize='sm'>No reminders have been set yet.</Text>}

      <Button colorScheme='blue' mt={5} onClick={addReminder}>Add a reminder</Button>
    </Box>
  )
}
